// ==========================================
// 💬 短信池 (SMS)
// ==========================================
export const smsPool = [
    // 固定的时间线短信
    {
        condition: (state) => state.round === 1,
        content: {
            id: 's_r1_boss',
            sender: "老板",
            text: "小码，下季度 AI 优先，好好干，期权少不了你的！",
            choices: [
                { text: "好的老板！保证完成任务！", effect: { self: +15, san: -5, rels: { boss: +10 }}, nextReply: "很好，我看好你，年轻人就是要拼搏。" },
                { text: "老板，推行 AI 可能需要多拨点预算...", effect: { money: 10000, self: -10, rels: { boss: -5 }}, nextReply: "预算没有，困难自己克服！我是看重你才把这事交给你的。" },
                { text: "（已读不回）", effect: { san: +5, self: -15, rels: { boss: -10 }}, nextReply: "人呢？？收到回复！" }
            ]
        }
    },
    {
        condition: (state) => state.round === 2 && state.model === 'gpt',
        content: { id: 's_f_gpt', sender: "运维组长", text: "老大，OpenAI 的账单出来了，上个月 API 调用费花了三百万..." }
    },
    {
        condition: (state) => state.round === 2 && state.model === 'safe',
        content: { id: 's_f_safe', sender: "业务方", text: "你们搞的那个私有化本地模型太弱智了！我们要申请公网权限！" }
    },
    {
        condition: (state) => state.round === 6,
        content: { id: 's_r6_mom', sender: "老妈", text: "儿子，我看新闻说现在电脑能自己写程序了，你那工作还安稳吗？实在不行回老家考公吧。" }
    },
    {
        condition: (state) => state.round === 7,
        content: {
            id: "s_mom_1",
            sender: "老妈",
            text: "儿啊，下周六是你爸生日，你能回来吃个饭吗？",
            choices: [
                { text: "好的妈，我一定回去。", effect: { rels: { family: +15 }, san: +10, self: -5 } }, // 回家陪家人，心情变好，但牺牲了卷工作的时间
                { text: "妈，最近项目要上线，实在走不开。", effect: { rels: { family: -10 }, self: +10 } } // 疏远家人，提升了公司地位
            ]
        }
    },

    // 动态数值触发短信
    {
        condition: (state) => state.industry >= 80,
        content: { id: 's_ind_80', sender: "猎头", text: "哥，有个 Web3+AI 的盘子，给您开三倍薪资，有兴趣聊聊吗？" }
    },
    {
        condition: (state) => state.stability <= 40,
        content: { id: 's_sta_40', sender: "运维报警系统", text: "【P0】致命错误！集群CPU超载 99%，AI正在无限死循环生成垃圾代码！" }
    },
    {
        condition: (state) => state.self <= 40,
        content: { id: 's_self_40', sender: "实习生小李", text: "哥，HR今天偷偷让我接手你的核心权限，我是不是要顶替你了？😭" }
    },
    {
        condition: (state) => state.self >= 60,
        content: { id: 's_self_80', sender: "老板", text: "干得漂亮！这波大换血给公司省了三个亿，年底给你报个长江商学院。" }
    },
    {
        condition: (state) => state.san <= 30,
        content: { id: 's_san_30', sender: "未知号码", text: "01010111 01100001 01101011 01100101 01110101 01110000 （快醒醒）" }
    },
    {
        condition: (state) => state.money >= 50000,
        content: { id: 's_money_50', sender: "瑞士私人银行", text: "尊贵的客户，您的海外信托架构已搭建完毕，随时可以转移资产。" }
    }
];